import { Component } from 'react';
import styled from 'styled-components';
import { ENTER_KEY, SPACE_KEY } from '../../../utils/keys';
import { Icon } from '../../Icon/Icon';

/*
REUSED CODE FROM OLD NAV
*/

const ItemElement = styled.li`
  margin: 0;
  cursor: pointer;
  display: flex;
  border: none;
  height: auto;
  text-align: left;
  border-top: none;
  line-height: 1em;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
  font-size: 14px;
  text-transform: none;
  font-weight: 400;
  box-shadow: none;
  padding: 15px 20px;
  box-sizing: border-box;
  white-space: normal;
  word-wrap: normal;
  text-decoration: none;

  &:hover,
  &:hover > * {
    background-color: ${({ theme }) => theme.vars.newColor.blue4};
    color: ${({ theme }) => theme.vars.newColor.darkGS1};
  }
`;

const IconElement = styled.span`
  display: inline-block;
  width: 25px;
  color: ${({ theme }) => theme.vars.newColor.darkGS1};
`;

const LabelElement = styled.span`
  display: inline-block;
`;

// This element is required to ensure the focus box is fully visible when
// keyboard tabbing
const ItemInnerElement = styled.div`
  display: flex;
`;

export interface IProps {
  icon?: string;
  onClick?: (e: any) => void;
}

export class MainNavFooterItem extends Component<IProps> {
  public render() {
    return (
      <ItemElement onClick={this.handleClick} onKeyUp={this.handleKeyUp}>
        <ItemInnerElement tabIndex={0}>
          {this.props.icon && (
            <IconElement>
              <Icon icon={this.props.icon} />
            </IconElement>
          )}
          <LabelElement>{this.props.children}</LabelElement>
        </ItemInnerElement>
      </ItemElement>
    );
  }

  private handleClick = (e: any) => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };

  private handleKeyUp = (e: any) => {
    if (this.props.onClick) {
      if (e.keyCode === ENTER_KEY || e.keyCode === SPACE_KEY) {
        this.props.onClick(e);
      }
    }
  };
}
